<div class="buy-ticket-container">
  @if (showDiningReservationLink) {
    <gds-spacer classes="spacer-50"></gds-spacer>
    <div class="second-container">
      <div
        class="coupon-content info-content contentTab"
        tabindex="0"
        role="button"
        [attr.aria-label]="pageLabels?.['dashboard.diningreservation']"
        (click)="getLink('Reservation')"
        (keydown.enter)="getLink('Reservation')"
        (keyup.Space)="getLink('Reservation')"
      >
        <div class="icon-content" aria-hidden="true">
          <div>
            <gds-svg
              icon-name="dinning-general-casual"
              fill-color="#222"
              width="32"
              height="32"
              class="adventure"
            ></gds-svg>
          </div>
          <gds-spacer classes="vertical-spacer-30"></gds-spacer>
          <h2 class="accountInformationCls">
            <gds-heading
              class="B1-W4 adventure"
              [data]="{
                heading: pageLabels?.['dashboard.diningreservation'],
              }"
            ></gds-heading>
          </h2>
        </div>
        <div class="account-icon-names" aria-hidden="true">
          <gds-spacer classes="vertical-spacer-20"></gds-spacer>
          <i aria-hidden="" class="icon icon-arrow-right"></i>
        </div>
      </div>
    </div>
  }

  <ng-container *udxFeatureFlag="FEATURE_FLAGS?.GUESTACCOUNT_FAVORITES">
    <gds-spacer classes="spacer-50"></gds-spacer>

    <div
      class="second-container"
      appA11yAction
      [a11yLabel]="favoritesCardConfig?.feature?.heading"
      (appA11yAction)="favoritesCardConfig?.navigate()"
    >
      <gds-card type="filled" elevation="1" uprInheritStyle>
        <gds-feature
          [data]="favoritesCardConfig?.feature"
          headingClasses="body-8"
        ></gds-feature>

        <div class="account-icon-names">
          <gds-svg
            [iconName]="favoritesCardConfig?.navigationIcon"
            [width]="favoritesCardConfig?.iconSize"
            [height]="favoritesCardConfig?.iconSize"
          />
        </div>
      </gds-card>
    </div>
  </ng-container>

  @if (showHotelReservationContent) {
    <app-hotel-reservation></app-hotel-reservation>
  }
  <div class="second-container">
    @if (showBuyTicketsLink) {
      <div class="small-container">
        <div
          class="club-universal contentTab"
          tabindex="0"
          role="button"
          [attr.aria-label]="pageLabels?.['dashboard.buyTickets']"
          (click)="redirectToWTS()"
          (keydown.enter)="redirectToWTS()"
          (keyup.Space)="redirectToWTS()"
          tabindex="0"
          role="button"
        >
          <div class="align-left" aria-hidden="true">
            <div class="icon-container">
              <gds-svg
                [iconName]="pageLabels?.['dashboard.buy_tickets']"
                height="32"
                width="32"
                fill-color="#222"
                class="adventure"
              ></gds-svg>
              <gds-spacer classes="vertical-spacer-20"></gds-spacer>
            </div>
            @if (isResort) {
              <div class="hotel-icon-names">
                <i aria-hidden="" class="icon icon-arrow-right"></i>
              </div>
            }
          </div>
          <!-- On Buy Tickets Link redirect to WTS Page-->
          <div class="buyTicketsCls" aria-hidden="true">
            @if (!showTicketContent) {
              <gds-buttons
                [data]="{
                  class: 'A3-W6',
                  type: 'tertiary',
                  label: pageLabels?.['dashboard.buyTickets'],
                  disabled: false,
                  target: '',
                }"
                (buttonClicked)="redirectToWTS()"
              >
              </gds-buttons>
            }
            @if (showTicketContent) {
              <h2 class="details-click">
                <gds-heading
                  class="A6-W4 adventure"
                  [data]="{
                    heading: pageLabels?.['dashboard.buyTickets'],
                  }"
                ></gds-heading>
              </h2>
            }
          </div>
        </div>
      </div>
    }
    @if (showLinkTicketsLink) {
      <div class="small-container">
        <div
          class="club-universal contentTab"
          tabindex="0"
          role="button"
          (click)="getLink('link_tickets')"
          (keydown.enter)="getLink('link_tickets')"
          (keyup.Space)="getLink('link_tickets')"
          id="getLinkContainer"
          [attr.aria-label]="pageLabels?.['viewEntEmpty.linkTicketsCTA']"
        >
          <div class="align-left" aria-hidden="true">
            <div class="icon-container">
              <gds-svg
                [iconName]="pageLabels?.['dashboard.link_tickets']"
                height="32"
                width="32"
                fill-color="#222"
                class="adventure"
              ></gds-svg>
              <gds-spacer classes="vertical-spacer-20"></gds-spacer>
            </div>

            @if (isResort) {
              <div class="hotel-icon-names">
                <i aria-hidden="" class="icon icon-arrow-right"></i>
              </div>
            }
          </div>
          <!-- On Register Tickets Link redirect to link tickets page-->
          @if (!showTicketContent) {
            <gds-buttons
              aria-hidden="true"
              [data]="{
                class: 'A3-W6 ticketctalink',
                type: 'tertiary',
                href: '',
                label: pageLabels?.['viewEntEmpty.linkTicketsCTA'],
                disabled: false,
                target: '',
              }"
            >
            </gds-buttons>
          }
          @if (showTicketContent) {
            <h2 class="details-click" aria-hidden="true">
              <gds-heading
                class="A6-W4 adventure"
                [data]="{
                  heading: pageLabels?.['viewEntEmpty.linkTicketsCTA'],
                }"
              ></gds-heading>
            </h2>
          }
        </div>
      </div>
    }
  </div>
  <gds-spacer classes="spacer-50"></gds-spacer>
  @if (showSavedTrips) {
    <div class="second-container">
      <div
        class="coupon-content info-content contentTab"
        tabindex="0"
        role="button"
        (click)="getLink('saved-trips')"
        (keydown.enter)="getLink('saved-trips')"
        [attr.aria-label]="pageLabels?.['dashboard.saved_trips_label']"
      >
        <div class="icon-content" aria-hidden="true">
          <div>
            <gds-svg
              [iconName]="pageLabels?.['dashboard.saved_trips_icon']"
              width="32"
              height="32"
              class="adventure"
            ></gds-svg>
          </div>
          <gds-spacer classes="vertical-spacer-30"></gds-spacer>
          <h2 class="purchaseHistoryCls">
            <gds-heading
              class="B1-W4 adventure"
              [data]="{
                heading: pageLabels?.['dashboard.saved_trips_label'],
              }"
            ></gds-heading>
          </h2>
        </div>
        <div class="account-icon-names" aria-hidden="true">
          <gds-heading
            [data]="{ heading: pageLabels?.['dashboard.saved_trips_heading'] }"
            class="B1-W4"
          ></gds-heading>

          <gds-spacer classes="vertical-spacer-20"></gds-spacer>
          <i aria-hidden="" class="icon icon-arrow-right"></i>
        </div>
      </div>
    </div>
  }
  <gds-spacer classes="spacer-50"></gds-spacer>
  <!-- Display 2 coupons with details-->

  <div class="coupon-container">
    <div
      class="coupon-content-data"
      tabindex="0"
      role="button"
      (click)="getLink('LINK_COUPONS')"
      (keydown.enter)="getLink('LINK_COUPONS')"
      (keyup.Space)="getLink('LINK_COUPONS')"
      [attr.aria-label]="
        pageLabels?.['dashboard.coupons'] + pageLabels?.['dashboard.details']
      "
    >
      <div class="icon-content" aria-hidden="true">
        <gds-svg
          [iconName]="pageLabels?.['dashboard.coupons_icon']"
          fill-color="#222"
          width="32"
          height="32"
          class="adventure"
        ></gds-svg>
        <gds-spacer classes="vertical-spacer-30"></gds-spacer>
        <h2>
          <gds-heading
            class="B1-W4"
            classes="adventure"
            [data]="{
              heading: pageLabels?.['dashboard.coupons'],
            }"
          ></gds-heading>
        </h2>
      </div>
      <div
        class="button-class contentTab details-click"
        (click)="getLink('LINK_COUPONS')"
        (keydown.enter)="getLink('LINK_COUPONS')"
        (keyup.Space)="getLink('LINK_COUPONS')"
        aria-hidden="true"
      >
        <gds-heading
          [data]="{ heading: pageLabels?.['dashboard.details'] }"
          class="B1-W4"
        ></gds-heading>
        <gds-spacer classes="vertical-spacer-20"></gds-spacer>
        @if (isResort) {
          <div class="hotel-icon-names">
            <i aria-hidden="" class="icon icon-arrow-right"></i>
          </div>
        }
      </div>
    </div>
    <gds-spacer classes="spacer-50"></gds-spacer>
    @if (tickets) {
      <div>
        <app-coupon-card
          [couponData]="couponData"
          [pageLabelsData]="pageLabels"
          [productCardCount]="displayProductCardCount"
          [fromDashboard]="fromDashboard"
        ></app-coupon-card>
        <gds-spacer classes="spacer-50"></gds-spacer>
      </div>
    } @else {
      <div>
        @if (couponData?.length === 0 || couponData === undefined) {
          <app-coupon-card
            [pageLabelsData]="pageLabels"
            [productCardCount]="displayProductCardCount"
            [fromDashboard]="fromDashboard"
          ></app-coupon-card>
        }
      </div>
    }
  </div>

  <gds-spacer classes="spacer-50"></gds-spacer>

  <!--To Display Product Order List-->
  <div
    class="second-container"
    (click)="getLink('order')"
    (keydown.enter)="getLink('order')"
    (keyup.Space)="getLink('order')"
    tabindex="0"
    [attr.aria-label]="pageLabels?.['dashboard.purchaseHistory']"
    role="button"
  >
    <div
      class="coupon-content info-content contentTab"
      aria-hidden="true"
      id="order_history"
      #purchaseHistoryEleRef
    >
      <div class="icon-content">
        <div>
          <gds-svg
            [iconName]="pageLabels?.['dashboard.order_history']"
            fill-color="#222"
            width="32"
            height="32"
            class="adventure"
          ></gds-svg>
        </div>
        <gds-spacer classes="vertical-spacer-30"></gds-spacer>
        <h2 class="purchaseHistoryCls">
          <gds-heading
            class="B1-W4 adventure"
            [data]="{
              heading: pageLabels?.['dashboard.purchaseHistory'],
            }"
          ></gds-heading>
        </h2>
      </div>
      <div
        class="account-icon-names"
        (keydown.enter)="getLink('order')"
        (keyup.Space)="getLink('order')"
      >
        @if (showTicketDetailsCta) {
          <gds-buttons
            [data]="{
              class: 'B1-W4 ticketctalink',
              type: 'tertiary',
              href: '',
              label: pageLabels?.['dashboard.details'],
              disabled: false,
              target: '',
            }"
          >
          </gds-buttons>
        }

        <gds-spacer classes="vertical-spacer-20"></gds-spacer>
        <i aria-hidden="true" class="icon icon-arrow-right"></i>
      </div>
    </div>
  </div>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <!--TO display account information for the user-->
  <div class="second-container">
    <div
      class="coupon-content info-content contentTab"
      tabindex="0"
      role="button"
      (click)="getLink('PROFILE')"
      (keydown.enter)="getLink('PROFILE')"
      (keyup.Space)="getLink('PROFILE')"
      role="button"
      [attr.aria-label]="pageLabels?.['dashboard.accountInformation']"
    >
      <div class="icon-content" aria-hidden="true">
        <div>
          <gds-svg
            [iconName]="pageLabels?.['dashboard.account_info']"
            fill-color="#222"
            width="32"
            height="32"
            class="adventure"
          ></gds-svg>
        </div>
        <gds-spacer classes="vertical-spacer-30"></gds-spacer>
        <h2 class="accountInformationCls">
          <gds-heading
            class="B1-W4 adventure"
            [data]="{
              heading: pageLabels?.['dashboard.accountInformation'],
            }"
          ></gds-heading>
        </h2>
      </div>
      <div
        class="account-icon-names"
        aria-hidden="true"
        (click)="getLink('PROFILE')"
        (keydown.enter)="getLink('PROFILE')"
        (keyup.Space)="getLink('PROFILE')"
      >
        @if (!showTicketContent) {
          <gds-buttons
            [data]="{
              class: 'B1-W4',
              type: 'tertiary',
              href: '',
              label: pageLabels?.['accountInfo.Details'],
              disabled: false,
              target: '',
            }"
          >
          </gds-buttons>
        }

        <gds-spacer classes="vertical-spacer-20"></gds-spacer>
        <i aria-hidden="true" class="icon icon-arrow-right"></i>
      </div>
    </div>
  </div>
</div>
<gds-spacer classes="spacer-80"></gds-spacer>
